var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.819026 1.8868C0.410751 1.45517 0.410751 0.755356 0.819026 0.323724C1.2273 -0.107908 1.88925 -0.107908 2.29752 0.323724L7.87328 6.21846C8.28155 6.65009 8.28155 7.34991 7.87328 7.78154L2.29752 13.6763C1.88924 14.1079 1.2273 14.1079 0.819024 13.6763C0.410749 13.2446 0.410749 12.5448 0.819024 12.1132L5.65554 7L0.819026 1.8868Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNext);
export default __webpack_public_path__ + "static/media/icon-next.a29a8367a0d171998cf9c9324007d354.svg";
export { ForwardRef as ReactComponent };